export interface NavLink {
  label: string;
  href: string;
}

export interface MovieCard {
  id: string;
  title: string;
  cover: string;
  duration: string;
  year: string;
  version: string;
  tags: string[];
  heat: string;
  desc: string;
}

export interface RankingItem {
  id: string;
  rank: number;
  title: string;
  meta: string;
  heat: number;
  trend: "up" | "down" | "flat";
  tag: string;
}

export interface RankingGroup {
  key: string;
  label: string;
  caption: string;
  items: RankingItem[];
}

export interface TopicTag {
  id: string;
  label: string;
  size: "sm" | "md" | "lg";
  count: string;
  tone: "primary" | "accent" | "secondary";
}

export interface ShortFilm {
  id: string;
  title: string;
  cover: string;
  minutes: string;
  tags: string[];
}

export interface TipItem {
  id: string;
  title: string;
  body: string;
}

export const navLinks: NavLink[] = [
  { label: "首页", href: "#top" },
  { label: "热度榜单", href: "#ranking" },
  { label: "影片合集", href: "#movies" },
  { label: "中文字幕", href: "#subtitle" },
  { label: "短片精选", href: "#shorts" },
  { label: "话题墙", href: "#topics" },
];

export const heroStats = [
  { value: "1,286", label: "在册视频条目" },
  { value: "64", label: "中文字幕版本" },
  { value: "9", label: "短片合集单元" },
  { value: "每日", label: "更新维护频率" },
];

export const heroTags = [
  "迷人的保姆完整版",
  "中文字幕",
  "电影长片",
  "剧情短片",
  "手机可看",
];

export const rankingGroups: RankingGroup[] = [
  {
    key: "all",
    label: "综合热榜",
    caption: "按近 24 小时综合播放热度排序",
    items: [
      { id: "r1", rank: 1, title: "迷人的保姆 完整版", meta: "电影长片 · 108 分钟 · 中文字幕", heat: 98, trend: "up", tag: "完整版" },
      { id: "r2", rank: 2, title: "迷人的保姆 剧情梳理篇", meta: "解读视频 · 22 分钟 · 中文字幕", heat: 93, trend: "up", tag: "解读" },
      { id: "r3", rank: 3, title: "迷人的保姆 未删减片段合集", meta: "合集 · 46 分钟 · 中文字幕", heat: 89, trend: "flat", tag: "合集" },
      { id: "r4", rank: 4, title: "迷人的保姆 幕后与花絮", meta: "花絮 · 18 分钟 · 中文字幕", heat: 84, trend: "down", tag: "花絮" },
      { id: "r5", rank: 5, title: "迷人的保姆 短片版", meta: "短片 · 27 分钟 · 中文字幕", heat: 80, trend: "up", tag: "短片" },
      { id: "r6", rank: 6, title: "迷人的保姆 人物关系导览", meta: "导览 · 15 分钟 · 中文字幕", heat: 76, trend: "flat", tag: "导览" },
    ],
  },
  {
    key: "week",
    label: "本周飙升",
    caption: "近 7 天热度涨幅更明显的条目",
    items: [
      { id: "w1", rank: 1, title: "迷人的保姆 电影版 1080P", meta: "画质收藏 · 中文字幕", heat: 96, trend: "up", tag: "画质" },
      { id: "w2", rank: 2, title: "迷人的保姆 短片版", meta: "短片 · 27 分钟 · 中文字幕", heat: 91, trend: "up", tag: "短片" },
      { id: "w3", rank: 3, title: "迷人的保姆 第三集 精选", meta: "剧集 · 中文字幕", heat: 88, trend: "up", tag: "剧集" },
      { id: "w4", rank: 4, title: "迷人的保姆 预告与片段", meta: "预告 · 6 分钟 · 中文字幕", heat: 82, trend: "flat", tag: "预告" },
      { id: "w5", rank: 5, title: "迷人的保姆 结局片段解读", meta: "解读 · 19 分钟 · 中文字幕", heat: 78, trend: "up", tag: "解读" },
      { id: "w6", rank: 6, title: "迷人的保姆 手机竖版", meta: "移动端适配 · 中文字幕", heat: 73, trend: "down", tag: "移动端" },
    ],
  },
  {
    key: "new",
    label: "新片速递",
    caption: "最近上架的可观看资源",
    items: [
      { id: "n1", rank: 1, title: "迷人的保姆 中文字幕精校版", meta: "新增 · 精校字幕", heat: 94, trend: "up", tag: "新上线" },
      { id: "n2", rank: 2, title: "迷人的保姆 短片精选卷二", meta: "新增 · 短片合集", heat: 90, trend: "up", tag: "新上线" },
      { id: "n3", rank: 3, title: "迷人的保姆 四季氛围版", meta: "新增 · 合集", heat: 85, trend: "flat", tag: "新上线" },
      { id: "n4", rank: 4, title: "迷人的保姆 配乐纯享片段", meta: "新增 · 音乐向", heat: 79, trend: "up", tag: "新上线" },
      { id: "n5", rank: 5, title: "迷人的保姆 场景摄影合集", meta: "新增 · 视觉向", heat: 74, trend: "flat", tag: "新上线" },
      { id: "n6", rank: 6, title: "迷人的保姆 评论区高赞热评", meta: "新增 · 互动向", heat: 70, trend: "up", tag: "新上线" },
    ],
  },
];

export const fullMovies: MovieCard[] = [
  {
    id: "m1",
    title: "迷人的保姆 完整版",
    cover: "https://readdy.ai/api/search-image?query=Warm%20cinematic%20film-still%20style%20poster%20of%20an%20elegant%20sunlit%20domestic%20interior%20with%20cream%20walls%2C%20linen%20curtains%20and%20dried%20flowers%20in%20a%20ceramic%20vase%2C%20vintage%20armchair%2C%20amber%20and%20terracotta%20color%20palette%2C%20soft%20editorial%20lighting%2C%20refined%20calm%20mood%2C%20high%20detail%2C%20no%20text&width=800&height=1000&seq=mbh-film-01&orientation=portrait",
    duration: "108 分钟",
    year: "2024",
    version: "完整版",
    tags: ["剧情", "都市", "中文字幕"],
    heat: "9.8 万人在看",
    desc: "完整版入口，保留全部场景与中文字幕，适合一次看完的观众。",
  },
  {
    id: "m2",
    title: "迷人的保姆 电影版 1080P",
    cover: "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20poster%20of%20a%20warm%20ivory%20hallway%20with%20a%20wooden%20console%20table%2C%20a%20small%20brass%20lamp%20and%20a%20framed%20abstract%20print%2C%20soft%20morning%20light%20through%20sheer%20curtains%2C%20terracotta%20and%20sand%20tones%2C%20quiet%20refined%20atmosphere%2C%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=800&height=1000&seq=mbh-film-02&orientation=portrait",
    duration: "104 分钟",
    year: "2024",
    version: "高清版",
    tags: ["高清", "电影", "中文字幕"],
    heat: "7.2 万人在看",
    desc: "1080P 画质版本，画面细节更清晰，字幕排布经过重新校对。",
  },
  {
    id: "m3",
    title: "迷人的保姆 未删减片段合集",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20cozy%20warm%20kitchen%20scene%20with%20cream%20cabinets%2C%20hanging%20copper%20pans%20and%20a%20bowl%20of%20citrus%20fruit%2C%20soft%20golden%20daylight%2C%20terracotta%20and%20amber%20tones%2C%20artistic%20editorial%20composition%2C%20calm%20domestic%20mood%2C%20high%20detail%2C%20no%20text&width=800&height=1000&seq=mbh-film-03&orientation=portrait",
    duration: "46 分钟",
    year: "2024",
    version: "合集",
    tags: ["合集", "花絮", "中文字幕"],
    heat: "5.6 万人在看",
    desc: "把分散的补充片段整理成一集，方便按顺序观看。",
  },
  {
    id: "m4",
    title: "迷人的保姆 短片版",
    cover: "https://readdy.ai/api/search-image?query=Artistic%20film%20still%20of%20a%20warm%20study%20room%20with%20a%20leather-bound%20book%20on%20a%20linen%20covered%20chair%2C%20dried%20pampas%20grass%20and%20a%20soft%20floor%20lamp%2C%20cream%20and%20sand%20palette%2C%20gentle%20evening%20light%2C%20refined%20editorial%20mood%2C%20high%20detail%2C%20no%20text&width=800&height=1000&seq=mbh-film-04&orientation=portrait",
    duration: "27 分钟",
    year: "2024",
    version: "短片",
    tags: ["短片", "精选", "中文字幕"],
    heat: "4.9 万人在看",
    desc: "缩短节奏的短片版本，适合碎片时间了解主要剧情。",
  },
  {
    id: "m5",
    title: "迷人的保姆 剧情梳理篇",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20warm%20neutral%20living%20space%20with%20a%20woven%20rug%2C%20ceramic%20tea%20set%20and%20a%20tall%20potted%20plant%20near%20a%20bright%20window%2C%20cream%20and%20terracotta%20palette%2C%20soft%20diffused%20daylight%2C%20calm%20artistic%20mood%2C%20high%20detail%2C%20no%20text&width=800&height=1000&seq=mbh-film-05&orientation=portrait",
    duration: "22 分钟",
    year: "2024",
    version: "解读",
    tags: ["解读", "剧情", "中文字幕"],
    heat: "4.1 万人在看",
    desc: "以时间线方式梳理人物关系与关键转折，降低观看门槛。",
  },
  {
    id: "m6",
    title: "迷人的保姆 幕后与花絮",
    cover: "https://readdy.ai/api/search-image?query=Artistic%20backstage%20style%20image%20of%20a%20warm%20vintage%20dressing%20room%20with%20a%20mirror%2C%20fabric%20swatches%20and%20dried%20flowers%20on%20a%20wooden%20dresser%2C%20amber%20and%20cream%20tones%2C%20soft%20warm%20light%2C%20refined%20editorial%20mood%2C%20high%20detail%2C%20no%20text&width=800&height=1000&seq=mbh-film-06&orientation=portrait",
    duration: "18 分钟",
    year: "2024",
    version: "花絮",
    tags: ["花絮", "幕后", "中文字幕"],
    heat: "3.4 万人在看",
    desc: "布景、灯光与配乐的幕后记录，附中文字幕说明。",
  },
];

export const topics: TopicTag[] = [
  { id: "t1", label: "迷人的保姆完整版", size: "lg", count: "1.8 万讨论", tone: "primary" },
  { id: "t2", label: "中文字幕", size: "md", count: "9,240 讨论", tone: "accent" },
  { id: "t3", label: "剧情解读", size: "md", count: "7,180 讨论", tone: "secondary" },
  { id: "t4", label: "短片合集", size: "lg", count: "6,530 讨论", tone: "accent" },
  { id: "t5", label: "人物关系", size: "sm", count: "4,120 讨论", tone: "secondary" },
  { id: "t6", label: "画面美学", size: "md", count: "3,880 讨论", tone: "primary" },
  { id: "t7", label: "配乐推荐", size: "sm", count: "3,010 讨论", tone: "accent" },
  { id: "t8", label: "结局讨论", size: "md", count: "2,760 讨论", tone: "secondary" },
  { id: "t9", label: "幕后花絮", size: "sm", count: "2,240 讨论", tone: "primary" },
  { id: "t10", label: "手机观看", size: "sm", count: "1,960 讨论", tone: "secondary" },
  { id: "t11", label: "未删减片段", size: "md", count: "1,720 讨论", tone: "accent" },
  { id: "t12", label: "观影指南", size: "sm", count: "1,380 讨论", tone: "primary" },
];

export const subtitlePicks: MovieCard[] = [
  {
    id: "s1",
    title: "迷人的保姆 · 精校中文字幕版",
    cover: "https://readdy.ai/api/search-image?query=Elegant%20cinematic%20still%20of%20a%20warm%20reading%20nook%20with%20a%20linen%20armchair%2C%20stacked%20books%20and%20a%20ceramic%20mug%20on%20a%20wooden%20side%20table%2C%20cream%20and%20sand%20tones%2C%20soft%20window%20light%2C%20refined%20editorial%20mood%2C%20high%20detail%2C%20no%20text&width=800&height=1000&seq=mbh-sub-01&orientation=portrait",
    duration: "106 分钟",
    year: "2024",
    version: "精校字幕",
    tags: ["双语字幕", "精校"],
    heat: "3.9 万人在看",
    desc: "逐句校对的时间轴，长句拆分为易读的两行字幕。",
  },
  {
    id: "s2",
    title: "迷人的保姆 · 简体字幕版",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20warm%20minimal%20dining%20area%20with%20a%20linen%20tablecloth%2C%20ceramic%20plates%20and%20a%20single%20stem%20flower%20in%20a%20slim%20vase%2C%20amber%20and%20cream%20palette%2C%20gentle%20daylight%2C%20calm%20artistic%20mood%2C%20high%20detail%2C%20no%20text&width=800&height=1000&seq=mbh-sub-02&orientation=portrait",
    duration: "104 分钟",
    year: "2024",
    version: "简体",
    tags: ["简体", "通用"],
    heat: "3.1 万人在看",
    desc: "面向大众观影习惯的简体字幕版本，用词更口语。",
  },
  {
    id: "s3",
    title: "迷人的保姆 · 听障友好字幕",
    cover: "https://readdy.ai/api/search-image?query=Warm%20artistic%20interior%20with%20a%20low%20wooden%20bench%2C%20folded%20wool%20blankets%20and%20a%20soft%20floor%20cushion%20near%20a%20bright%20window%2C%20cream%20and%20terracotta%20tones%2C%20calm%20diffused%20light%2C%20refined%20mood%2C%20high%20detail%2C%20no%20text&width=800&height=1000&seq=mbh-sub-03&orientation=portrait",
    duration: "108 分钟",
    year: "2024",
    version: "听障友好",
    tags: ["环境音标注", "听障友好"],
    heat: "2.4 万人在看",
    desc: "额外标注环境音与情绪提示，方便听障观众理解场景。",
  },
  {
    id: "s4",
    title: "迷人的保姆 · 双语对照字幕",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20warm%20tidy%20entryway%20with%20a%20woven%20basket%2C%20folded%20linen%20and%20a%20small%20potted%20fern%20on%20a%20wooden%20cabinet%2C%20cream%20and%20sand%20tones%2C%20soft%20ambient%20light%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=1000&seq=mbh-sub-04&orientation=portrait",
    duration: "104 分钟",
    year: "2024",
    version: "双语",
    tags: ["中英对照", "学习向"],
    heat: "2.0 万人在看",
    desc: "中英对照排列，适合想同时对照原文的观众。",
  },
];

export const shortFilms: ShortFilm[] = [
  {
    id: "sh1",
    title: "晨间片段",
    cover: "https://readdy.ai/api/search-image?query=Artistic%20warm%20square%20image%20of%20a%20sunlit%20breakfast%20corner%20with%20a%20ceramic%20cup%2C%20toast%20on%20a%20linen%20napkin%20and%20a%20small%20vase%20of%20dried%20flowers%2C%20cream%20and%20amber%20tones%2C%20soft%20morning%20light%2C%20refined%20calm%20mood%2C%20high%20detail%2C%20no%20text&width=700&height=700&seq=mbh-short-01&orientation=squarish",
    minutes: "6 分钟",
    tags: ["日常", "轻松"],
  },
  {
    id: "sh2",
    title: "书房独白",
    cover: "https://readdy.ai/api/search-image?query=Artistic%20warm%20square%20image%20of%20an%20open%20book%20and%20reading%20glasses%20on%20a%20wooden%20desk%20with%20a%20soft%20brass%20lamp%2C%20cream%20and%20terracotta%20palette%2C%20quiet%20afternoon%20light%2C%20refined%20editorial%20mood%2C%20high%20detail%2C%20no%20text&width=700&height=700&seq=mbh-short-02&orientation=squarish",
    minutes: "9 分钟",
    tags: ["独白", "叙事"],
  },
  {
    id: "sh3",
    title: "庭院黄昏",
    cover: "https://readdy.ai/api/search-image?query=Artistic%20warm%20square%20image%20of%20a%20small%20garden%20patio%20with%20terracotta%20pots%2C%20olive%20branches%20and%20a%20wooden%20chair%2C%20golden%20dusk%20light%2C%20cream%20and%20sand%20tones%2C%20calm%20refined%20mood%2C%20high%20detail%2C%20no%20text&width=700&height=700&seq=mbh-short-03&orientation=squarish",
    minutes: "7 分钟",
    tags: ["氛围", "黄昏"],
  },
  {
    id: "sh4",
    title: "雨夜灯下",
    cover: "https://readdy.ai/api/search-image?query=Artistic%20warm%20square%20image%20of%20a%20rain%20speckled%20window%20at%20night%20with%20a%20warm%20lamp%20glow%20inside%2C%20a%20blanket%20on%20an%20armchair%20and%20a%20ceramic%20mug%2C%20amber%20and%20cream%20tones%2C%20cozy%20refined%20mood%2C%20high%20detail%2C%20no%20text&width=700&height=700&seq=mbh-short-04&orientation=squarish",
    minutes: "11 分钟",
    tags: ["雨夜", "情绪"],
  },
];

export const tips: TipItem[] = [
  {
    id: "tip1",
    title: "怎么找到完整版而不是片段合集？",
    body: "在热度榜单里带「完整版」标签的条目通常时长在 100 分钟以上，点开卡片上的时长信息即可快速区分完整版与短片合集。",
  },
  {
    id: "tip2",
    title: "中文字幕版本有什么区别？",
    body: "精校版侧重时间轴与断句，双语版适合对照原文，听障友好版额外标注环境音。按你的观看习惯挑选即可。",
  },
  {
    id: "tip3",
    title: "手机上观看体验如何？",
    body: "页面在手机与电脑端均可正常浏览，卡片与榜单会自动堆叠，横屏时封面比例保持稳定，不会出现变形。",
  },
  {
    id: "tip4",
    title: "内容多久更新一次？",
    body: "热度榜单按日滚动，新片速递在有条目上架时同步更新，字幕版本调整也会在对应卡片上标注版本说明。",
  },
];

export const footerLinks = [
  { title: "资源导航", items: ["迷人的保姆在线观看", "迷人的保姆电影", "迷人的保姆完整版", "迷人的保姆短片"] },
  { title: "字幕专区", items: ["中文字幕", "精校字幕", "双语对照", "听障友好"] },
  { title: "内容单元", items: ["热度榜单", "影片合集", "短片精选", "话题墙"] },
  { title: "关于本站", items: ["观看指引", "更新说明", "版权声明", "联系我们"] },
];